export const getEIS = mumber => {
  return (
    "https://zakupki.gov.ru/epz/order/extendedsearch/results.html?searchString=" +
    mumber +
    "&morphology=on&search-filter=%D0%94%D0%B0%D1%82%D0%B5+%D1%80%D0%B0%D0%B7%D0%BC%D0%B5%D1%89%D0%B5%D0%BD%D0%B8%D1%8F&pageNumber=1&sortDirection=false&recordsPerPage=_10&showLotsInfoHidden=false&fz44=on&fz223=on&sortBy=UPDATE_DATE&af=on&ca=on&pc=on&pa=on&currencyIdGeneral=-1"
  );
};
